<script>
import { etcardinfo, getUser } from "../../api/user.js";
import VueCoreImageUpload from "vue-core-image-upload";
import { VUE_APP_API_URL } from "@utils";
export default {
  data() {
    return {
      disabled: false,
      real_name: "",
      card_id: "",
      showAddress: false,
      valueArr: [0, 0],
      id: 0,
      addressText: "请选择区域",
      addressList: [],
      province: [],
      address: {},
      city: [],
      district: [],
      img1: "",
      img2: "",
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      }
    };
  },
  components: {
    VueCoreImageUpload
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.img1 = res.data.url;
    },
    imageuploaded2(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.img2 = res.data.url;
    },
    sureAddress() {
      let province = this.province[this.valueArr[0]].n;
      let city = this.city[this.valueArr[1]].n;
      // let district = this.district[this.valueArr[2]].n;
      this.addressText = province + " " + city;
      this.cityId = this.district[this.valueArr[1]].v;
      this.address = {
        province,
        city
      };
      this.showAddress = false;
    },
    recity(arr) {
      let province = [],
        city = [],
        area = [];
      if (arr.length) {
        let citychildren = arr[0].c || [];
        let areachildren = citychildren.length ? citychildren[0].c || [] : [];
        arr.forEach(item => {
          province.push(item);
        });
        citychildren.forEach(item => {
          city.push(item);
        });
        areachildren.forEach(item => {
          area.push(item);
        });
        this.province = province;
        this.city = city;
        this.district = area;
      }
    },
    changePicker(e) {
      let indexArr = e.detail.value;
      if (indexArr[0] !== this.valueArr[0]) {
        this.valueArr = [indexArr[0], 0, 0];
        this.city = this.addressList[indexArr[0]].c;
        // this.district = this.addressList[indexArr[0]].c[0].c;
        return;
      }
      if (indexArr[1] !== this.valueArr[1]) {
        this.valueArr = [indexArr[0], indexArr[1], 0];
        // this.district = this.addressList[indexArr[0]].c[indexArr[1]].c;
        return;
      }
      this.valueArr = indexArr;
    },
    // 获取用户信息
    getUserInfo() {
      getUser().then(res => {
        if (res.data.card_id) this.disabled = true;
        this.real_name = res.data.real_name;
        this.card_id = res.data.card_id;
        this.img1 = res.data.card_img1;
        this.img2 = res.data.card_img2;
      });
    },

    // 提交认证
    submitFun() {
      if (!this.real_name)
        return this.$dialog.toast({
          mes: "真实姓名输入为空"
        });
      let reg = /^(\d{18,18}|\d{15,15}|\d{17,17}X)$/;
      if (!reg.test(this.card_id))
        return this.$dialog.toast({
          mes: "身份证号码输入有误或为空"
        });
      etcardinfo({
        real_name: this.real_name,
        card_id: this.card_id,
        card_img1: this.img1,
        card_img2: this.img2
      })
        .then(res => {
          return this.$dialog.toast({
            mes: res.msg
          });
        })
        .catch(err => {
          return this.$dialog.toast({
            mes: err.msg
          });
        });
    }
  }
};
</script>

<template>
  <div>
    <div class="form">
      <div class="item">
        <div class="tite">真实姓名</div>
        <input
          type="text"
          placeholder="请输入认证姓名"
          v-model="real_name"
          :disabled="disabled"
        />
      </div>
      <div class="item">
        <div class="tite">身份证号码</div>
        <input
          type="idcard"
          placeholder="请输入认证身份证号码"
          maxlength="18"
          v-model="card_id"
          :disabled="disabled"
        />
      </div>

      <div class="item" style="border: 0;">
        <div class="title">法人身份证</div>
        <div class="identity" style="display: flex;">
          <div class="img" v-if="!disabled">
            <VueCoreImageUpload
              class="btn btn-primary"
              :crop="false"
              compress="80"
              @imageuploaded="imageuploaded"
              :headers="headers"
              :max-file-size="10485760"
              :credentials="false"
              inputAccept="image/*"
              inputOfFile="file"
              :url="url"
              ref="upImg"
            >
              <div class="pictrue">
                <img :src="img1" v-if="img1" />
                <img
                  src="../../assets/images/add_from.png"
                  v-else
                  class="alter"
                />
              </div>
            </VueCoreImageUpload>
          </div>
          <div class="img" v-else>
            <img :src="img1" alt="" />
          </div>

          <div class="img" v-if="!disabled">
            <VueCoreImageUpload
              class="btn btn-primary"
              :crop="false"
              compress="80"
              @imageuploaded="imageuploaded2"
              :headers="headers"
              :max-file-size="10485760"
              :credentials="false"
              inputAccept="image/*"
              inputOfFile="file"
              :url="url"
              ref="upImg"
            >
              <div class="pictrue">
                <img :src="img2" v-if="img2" />
                <img
                  src="../../assets/images/add_back.png"
                  v-else
                  class="alter"
                />
              </div>
            </VueCoreImageUpload>
          </div>
          <div class="img" v-else>
            <img :src="img2" alt="" />
          </div>
        </div>
      </div>

      <div class="item">
        <div class="btn2" @click="submitFun" v-if="!disabled">
          提交认证
        </div>
        <div class="btn2" v-if="disabled">
          已认证
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 0.3rem;
  background-color: #fff;
  margin-top: 0.2rem;

  .item2 {
    height: 0.9rem;
    background-color: #fff;
    font-size: 0.3rem;
    border-bottom: 0.01rem solid #eee;

    .left {
      width: 1.95rem;
      color: #333;
    }

    .right {
      width: 4.75rem;

      .iconfont {
        color: #0e98fd;
        font-size: 0.5rem;
      }
    }
  }

  .item {
    margin-bottom: 0.3rem;
    border-bottom: 0.01rem solid #eee;

    &:last-child {
      margin-bottom: 0;
      border-bottom: 0;
    }

    .title {
      font-size: 0.3rem;
      color: #666;
    }

    input {
      width: 100%;
      height: 0.9rem;
      line-height: 0.9rem;
      font-size: 0.3rem;
      color: #666;
    }

    .btn2 {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 0.9rem;
      background-color: #0e98fd;
      font-size: 0.3rem;
      color: #fff;
      border-radius: 0.6rem;
      margin-top: 0.6rem;
    }
    .identity {
      width: 100%;
      height: 2.2rem;
      display: flex;
      justify-content: space-between;
      margin: 0.3rem 0 0;

      .img {
        width: 3.28rem;
        height: 2.2rem;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.32rem;
        border: 1px dashed #eee;

        img {
          max-height: 2.2rem;
          overflow: hidden;
        }
      }
    }
  }
}

.addressWrapper {
  .btns {
    width: 100%;
    height: 0.86rem;
    position: fixed;
    bottom: 6rem;
    left: 0;
    z-index: 556;
    background-color: #fff;
    text-align: center;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    border-bottom: 0.01rem solid #eee;

    .cancel {
      color: #666;
    }

    .sure {
      color: #007aff;
    }
  }

  .pickerView {
    width: 100%;
    height: 6rem;
    position: fixed !important;
    bottom: 0;
    left: 0;
    z-index: 556;
    background-color: #fff;
    text-align: center;
  }
  .item0 {
    flex-wrap: wrap;
    padding: 0.2rem 0;

    .title {
      width: 100%;

      title {
        font-size: 0.24rem;
        color: #999;
      }
    }

    .add {
      margin: 0.3rem 0 0;

      .img {
        width: 2rem;
        height: 2rem;
        border-radius: 0.1rem;
        margin-right: 0.4rem;
        overflow: hidden;
      }
    }

    .license {
      margin: 0.3rem 0 0;

      .img {
        width: 2.2rem;
        height: 1.52rem;
        position: relative;

        img {
          max-height: 1.52rem;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
